import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { NAV_ITEMS, scrollToId } from "@/lib/site";
import { track } from "@/lib/analytics";

const CONTACT_EMAIL = "moustakas@natsuintelligence.com";
// NATSU Intelligence LinkedIn Company Page URL — leave empty until officially supplied.
const COMPANY_LINKEDIN = "";

export default function Footer() {
  return (
    <footer id="site-footer" className="on-dark bg-natsu-navy-deep" data-testid="site-footer">
      <div className="site-container py-12 sm:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.3fr_1fr] lg:gap-20">
          <div>
            <img
              src="/natsu-logo-footer.png"
              alt="NATSU Intelligence — AI-Native Commercial Intelligence for Global Maritime Trade"
              className="h-[184px] w-auto sm:h-[212px] lg:h-[228px]"
              draggable="false"
            />
            <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-natsu-warm-white/75">
              Commercial Intelligence Infrastructure for Global Maritime Trade.
            </p>
            <p className="mt-6 text-[13px] text-natsu-warm-white/55">
              natsuintelligence.com
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-contact-email"
              className="mt-1.5 inline-block text-[13.5px] text-natsu-warm-white/85 transition-colors hover:text-natsu-warm-white"
            >
              {CONTACT_EMAIL}
            </a>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <p className="eyebrow text-natsu-warm-white/55">Explore</p>
              <ul className="mt-4 space-y-2.5">
                {NAV_ITEMS.map((item) => (
                  <li key={item.id}>
                    <button
                      onClick={() => scrollToId(item.id)}
                      className="text-[14px] text-natsu-warm-white/75 transition-colors hover:text-natsu-warm-white"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="eyebrow text-natsu-warm-white/55">Legal &amp; Contact</p>
              <ul className="mt-4 space-y-2.5">
                <li>
                  <Link
                    to="/privacy"
                    onClick={() => track("privacy_policy_opened")}
                    className="text-[14px] text-natsu-warm-white/75 transition-colors hover:text-natsu-warm-white"
                    data-testid="footer-privacy-link"
                  >
                    Privacy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms"
                    onClick={() => track("terms_of_use_opened")}
                    className="text-[14px] text-natsu-warm-white/75 transition-colors hover:text-natsu-warm-white"
                    data-testid="footer-terms-link"
                  >
                    Terms / Legal
                  </Link>
                </li>
                <li>
                  <button
                    onClick={() => scrollToId("pilot")}
                    className="text-[14px] text-natsu-warm-white/75 transition-colors hover:text-natsu-warm-white"
                  >
                    Request a Pilot
                  </button>
                </li>
                {COMPANY_LINKEDIN && (
                  <li>
                    <a
                      href={COMPANY_LINKEDIN}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="footer-company-linkedin"
                      className="inline-flex items-center gap-1.5 text-[14px] text-natsu-warm-white/75 transition-colors hover:text-natsu-warm-white"
                    >
                      <Linkedin className="h-3.5 w-3.5" strokeWidth={1.8} />
                      LinkedIn
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-1.5 border-t border-white/12 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[13px] text-natsu-warm-white/60">
            © {new Date().getFullYear()} NATSU Intelligence. All rights reserved.
          </p>
          <p className="text-[13px] text-natsu-warm-white/60">
            Built for global maritime trade.
          </p>
        </div>
      </div>
    </footer>
  );
}
